/* Modern palette retune, layered over palette.css. Every built-in theme maps
   its semantic tokens onto these scales, so retuning them here restyles the
   whole app at once: neutral cool grays instead of saturated navy, a calmer
   violet accent, and a chart palette that reads well on light and dark. */
:root {
  --palette-gray50: #fafafb;
  --palette-gray80: #f5f5f7;
  --palette-gray100: #ededf0;
  --palette-gray150: #dfdfe4;
  --palette-gray200: #c7c7cf;
  --palette-gray300: #a1a1ab;
  --palette-gray400: #7a7a84;
  --palette-gray500: #575760;
  --palette-gray600: #3b3b42;
  --palette-gray700: #27272d;
  --palette-gray800: #18181c;
  --palette-gray900: #0e0e11;

  --palette-navy50: #f8f9fb;
  --palette-navy100: #eef0f4;
  --palette-navy150: #e3e6ec;
  --palette-navy200: #cbd0da;
  --palette-navy300: #a6adbb;
  --palette-navy400: #808898;
  --palette-navy500: #616878;
  --palette-navy600: #474d5a;
  --palette-navy700: #2f333d;
  --palette-navy800: #20232a;
  --palette-navy900: #16181d;

  --palette-purple50: #f6f5ff;
  --palette-purple100: #efedff;
  --palette-purple125: #e4e0ff;
  --palette-purple150: #d8d2ff;
  --palette-purple200: #b7adff;
  --palette-purple300: #9a8bff;
  --palette-purple400: #826ff8;
  --palette-purple500: #6e55ee;
  --palette-purple600: #5d44d8;
  --palette-purple700: #4b36b2;
  --palette-purple800: #3a2a8a;
  --palette-purple900: #2a1f63;

  --palette-hover: #f7f7f9;
  --palette-border: #e6e7eb;

  --palette-chartQual1: #6b8afd;
  --palette-chartQual2: #2fbf8f;
  --palette-chartQual3: #f2b54a;
  --palette-chartQual4: #ef6f6c;
  --palette-chartQual5: #a184fb;
  --palette-chartQual6: #36bdd3;
  --palette-chartQual7: #ee8cbe;
  --palette-chartQual8: #9cc45a;
  --palette-chartQual9: #8e96a8;

  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;

  /* Dark-leaning defaults (used by midnight); light and dark redefine them. */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
  --shadow-md: 0 1px 2px rgba(0, 0, 0, 0.35), 0 4px 14px rgba(0, 0, 0, 0.3);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.45), 0 24px 56px rgba(0, 0, 0, 0.4);
  --focus-ring: 0 0 0 3px rgba(130, 111, 248, 0.3);
}

/* Native controls (checkboxes, radios, range sliders) pick up the accent. */
:root {
  accent-color: var(--palette-purple500);
}
